import prettyMilliseconds from "pretty-ms";
import { Timestamp } from "~/format";
import { nanosecondsToMilliseconds } from "~/lib/dates";
import type { Log, Tag } from "~/lqs";
import type { LogInstantTag, LogLevelTag, LogRangeTag, LogTag } from "./types";

export function checkIsLogLevelTag(tag: LogTag): tag is LogLevelTag {
  return tag.topicId === null && tag.startTime === null && tag.endTime === null;
}

export function checkIsLogInstantTag(tag: LogTag): tag is LogInstantTag {
  return tag.topicId === null && tag.startTime !== null && tag.endTime === null;
}

export function checkIsLogRangeTag(tag: LogTag): tag is LogRangeTag {
  return tag.topicId === null && tag.startTime !== null && tag.endTime !== null;
}

export function checkIsLogTag(tag: Tag): tag is LogTag {
  return (
    tag.topicId === null && (tag.startTime !== null || tag.endTime === null)
  );
}

export function pairTagWithType(
  tag: LogTag,
):
  | { tag: LogLevelTag; type: "log-level" }
  | { tag: LogInstantTag; type: "log-instant" }
  | { tag: LogRangeTag; type: "log-range" } {
  switch (true) {
    case checkIsLogLevelTag(tag): {
      return { tag, type: "log-level" };
    }
    case checkIsLogInstantTag(tag): {
      return { tag, type: "log-instant" };
    }
    case checkIsLogRangeTag(tag): {
      return { tag, type: "log-range" };
    }
    default: {
      throw new Error("Unexpected type of tag");
    }
  }
}

export function checkIsTimestampedLogTag(
  tag: LogTag,
): tag is LogInstantTag | LogRangeTag {
  return checkIsLogInstantTag(tag) || checkIsLogRangeTag(tag);
}

export function renderRecorded(log: Log) {
  return <Timestamp value={log.startTime} />;
}

export function renderDuration(log: Log) {
  const { startTime, endTime } = log;

  return startTime === null || endTime === null
    ? "-"
    : prettyMilliseconds(nanosecondsToMilliseconds(endTime - startTime), {
        secondsDecimalDigits: 0,
      });
}
